import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function Events(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#BBEBFA"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M23 26C24.1 26 25 25.1 25 24V10C25 8.9 24.1 8 23 8H22V6H20V8H12V6H10V8H9C7.89 8 7.01 8.9 7.01 10L7 24C7 25.1 7.89 26 9 26H23ZM13 17V15H11V17H13ZM9 12H23V10H9V12ZM23 14V24H9V14H23ZM21 17V15H19V17H21ZM17 17H15V15H17V17Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
